export default [
    {   // [0]
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "From",
        placeholder: "Date",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {   // [1]
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "To",
        placeholder: "Date",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Area",
        labelName: "name",
        options: [],
        model: null,
        cols: 12,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "Discount Type",
        labelName: "name",
        options: [],
        model: null,
        cols: 12,
    },
    {
        type: "v-select",
        margin: true,
        showLabel: true,
        label: "ESTADO",
        labelName: "name",
        options: [
            { name: "TODOS", id: null },
            { name: "PENDIENTE", id: "Pending" },
            { name: "APROBADO", id: "Approved" },
        ],
        model: null,
        cols: 12,
    },
];